import styled from 'styled-components';

export const SellingAccountsWrapper = styled.div`
  max-height: 480px;
`;

export const SellingAccountsTitleWrapper = styled.div`
  margin-block-end: ${({ theme }) => theme.spacing.xsmall.default};
`;

export const SellingAccountTileCheckboxWrapper = styled.div`
  margin-block-end: ${({ theme }) => theme.spacing.xsmall.default};
`;

export const SellingAccountPagination = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-block-start: ${({ theme }) => theme.spacing.small.default};
  height: 31px;
`;
